import { useState } from 'react';
import { Button, Typography } from '@sweep-io/sweep-design';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';
import Stack from '@mui/material/Stack';
import { useFunnelMaps } from '../../funnel-maps/useFunnelMaps';
import useSweepNavigate from '../../../../navigation-utils/useSweepNavigate';
import { appRoutes } from '../../../../constants/appRoutes';
import Divider from '@mui/material/Divider';
import MonitoringAgentsPopover from './MonitoringAgentsPopover';
import { MonitoringAgentsButton } from './MonitoringAgentsButton';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { AI_AGENTS_EVENTS } from '../../../../services/events';

export const AgentsEntryPoint = ({
  setIsLoading,
  popoverAnchorEl,
}: {
  setIsLoading: (isLoading: boolean) => void;
  popoverAnchorEl: HTMLElement | null;
}) => {
  const { monitoringOnHomepage, processMiningV2 } = useFeatureToggle();
  const { createNewFunnelMap } = useFunnelMaps();
  const { navigate } = useSweepNavigate();
  const sendBiEvent = useSendBiEvent();

  const [displayMonitoringPopover, setDisplayMonitoringPopover] = useState<boolean>(false);

  const handleCreateFunnelMap = async () => {
    sendBiEvent({ name: AI_AGENTS_EVENTS.generateProcessMiningFromHomepage });
    setIsLoading(true);
    createNewFunnelMap();
    // This function includes navigation, this will unmount this component, so no need to setIsLoading(false)
  };

  const handleNavigateToAgenticLayer = () => {
    setIsLoading(true);
    navigate(appRoutes.agenticLayer.route);
    // Navigation will unmount this component, so no need to setIsLoading(false)
  };

  const renderProcessMining = (
    <Button
      variant="flat-blue"
      startIconName={processMiningV2 ? 'ProcessMining' : undefined}
      size="large"
      onClick={processMiningV2 ? handleCreateFunnelMap : handleNavigateToAgenticLayer}
    >
      <Typography variant={monitoringOnHomepage ? 'caption-medium' : 'body'}>
        {processMiningV2 ? 'Generate Metadata Maps' : 'See what other agents can do'}
      </Typography>
    </Button>
  );

  if (!monitoringOnHomepage) {
    return renderProcessMining;
  }

  return (
    <>
      <Stack direction="row" gap="20px">
        <MonitoringAgentsButton openMonitoringPopover={() => setDisplayMonitoringPopover(true)} />
        <Divider orientation="vertical" flexItem />
        {renderProcessMining}
      </Stack>

      <MonitoringAgentsPopover
        open={displayMonitoringPopover}
        anchorEl={popoverAnchorEl}
        onClose={() => setDisplayMonitoringPopover(false)}
      />
    </>
  );
};
